import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({
  selector: '[vmspdbUiHeaderActionHost]',
  standalone: false,
})
export class HeaderActionHostDirective {
  viewContainerRef = inject(ViewContainerRef);
}
